import {createSlice} from '@reduxjs/toolkit';
import {RootState} from '../store';

export interface Typology {
  id: number;
  name: string;
}

interface TypologyState {
  typologies: Typology[];
}

const initialState: TypologyState = {
  typologies: []
};

export const typologySlice = createSlice({
  name: 'typologySlice',
  initialState,
  reducers: {
    updateTypologies: (state, action) => {
      state.typologies = action.payload;
    },
  },
});

export const typologiesInformation = (state: RootState) =>
  state.typologySlice.typologies;
